import axios from "axios";
const production = !process.env.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV === "production";
const API_BASE_URL = production ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV;


const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
});


axiosInstance.interceptors.request.use(
    (config) => {
        config.headers.Authorization = `Bearer ndsvkjndsvk vsdvndsjkvndsjk`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export async function signInUser(username, password) {

    try {
        console.log(API_BASE_URL);

        const response = await axiosInstance.post('/oauth2/login', {
            username,
            password,
        });
        return response.data;
    } catch (e) {
        console.log(e);
        return null;
    }

}

export async function checkToken(token) {

    const response = await axiosInstance.post(`/oauth2/me`, {
        token,
    });
    return response.data;

}